module.exports = [
	{
		"id": "pulm-003-dining-stool",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "SE006",
					"variationValues": {
						"body": "white_oak"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL008",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL008",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				}
			]
		}
	},
	{
		"id": "pulm-004-coffee-table",
		"type": 0,
		"data": {
			"table_top": [
				{
					"id": "ST003",
					"variationValues": {
						"body": "white_oak"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL004",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL004",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL004",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL004",
					"variationValues": {
						"body": "white"
					}
				}
			]
		}
	},
	{
		"id": "pulm-003-coffee-table",
		"type": 0,
		"data": {
			"table_top": [
				{
					"id": "ST001",
					"variationValues": {
						"body": "white"
					}
				}
			],
			"center_chair_leg": [
				{
					"id": "CL002"
				}
			]
		}
	},
	{
		"id": "pulm-005-coffee-table",
		"type": 0,
		"data": {
			"table_top": [
				{
					"id": "ST003",
					"variationValues": {
						"body": "walnut"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL010",
					"variationValues": {
						"body": "walnut"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "walnut"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "walnut"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "walnut"
					}
				}
			]
		}
	},
	{
		"id": "pulm-007-coffee-table",
		"type": 0,
		"data": {
			"table_top": [
				{
					"id": "ST001",
					"variationValues": {
						"body": "white_oak"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL010",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white_oak"
					}
				}
			]
		}
	},
	{
		"id": "pult-002-dining-stool",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "SE014",
					"variationValues": {
						"body": "walnut"
					}
				}
			],
			"center_chair_leg": [
				{
					"id": "CL002"
				}
			]
		}
	},
	{
		"id": "pult-005-dining-stool",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "SE014",
					"variationValues": {
						"body": "white"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL001",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL001",
					"variationValues": {
						"body": "black"
					}
				},
				{
					"id": "CL001",
					"variationValues": {
						"body": "grey"
					}
				},
				{
					"id": "CL001",
					"variationValues": {
						"body": "dark_grey"
					}
				}
			]
		}
	},
	{
		"id": "pult-002-dining-chair",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "CN005",
					"variationValues": {
						"body": "white_oak"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL014",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL014",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL014",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL014",
					"variationValues": {
						"body": "white_oak"
					}
				}
			]
		}
	},
	{
		"id": "pult-002-dining-stool",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "SE014",
					"variationValues": {
						"body": "walnut"
					}
				}
			],
			"center_chair_leg": [
				{
					"id": "CL002"
				}
			]
		}
	},
	{
		"id": "pult-003-dining-chair",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "CN005",
					"variationValues": {
						"body": "white_oak"
					}
				}
			],
			"center_chair_leg": [
				{
					"id": "CL002"
				}
			]
		}
	},
	{
		"id": "pult-006-dining-stool",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "SE013",
					"variationValues": {
						"body": "black"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL005",
					"variationValues": {
						"body": "black",
						"leg_cover": "copper"
					}
				},
				{
					"id": "CL005",
					"variationValues": {
						"body": "black",
						"leg_cover": "copper"
					}
				},
				{
					"id": "CL005",
					"variationValues": {
						"body": "black",
						"leg_cover": "copper"
					}
				},
				{
					"id": "CL005",
					"variationValues": {
						"body": "black",
						"leg_cover": "copper"
					}
				}
			]
		}
	},
	{
		"id": "pult-007-dining-chair",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "CN005",
					"variationValues": {
						"body": "black"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "black"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "black"
					}
				}
			]
		}
	},
	{
		"id": "pult-008-dining-chair",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "CN005",
					"variationValues": {
						"body": "white"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL010",
					"variationValues": {
						"body": "black"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "black"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				}
			]
		}
	},
	{
		"id": "pult-012-dining-chair",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "SE014",
					"variationValues": {
						"body": "white_oak"
					}
				}
			],
			"back_rest": [
				{
					"id": "BR302",
					"variationValues": {
						"body": "white_oak"
					}
				}
			],
			"back_support": [
				{
					"id": "BS106",
					"variationValues": {
						"body": "black"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL001",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL001",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL001",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL001",
					"variationValues": {
						"body": "white"
					}
				}
			]
		}
	},
	{
		"id": "pult-013-dining-chair",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "SE014",
					"variationValues": {
						"body": "walnut"
					}
				}
			],
			"back_rest": [
				{
					"id": "BR306",
					"variationValues": {
						"body": "white"
					}
				}
			],
			"back_support": [
				{
					"id": "BS106",
					"variationValues": {
						"body": "white"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white"
					}
				}
			]
		}
	},
	{
		"id": "default",
		"type": 1,
		"data": {
			"seat": [
				{
					"id": "SE014",
					"variationValues": {
						"body": "white_oak"
					}
				}
			],
			"back_rest": [
				{
					"id": "BR306",
					"variationValues": {
						"body": "white_oak"
					}
				}
			],
			"back_support": [
				{
					"id": "BS106",
					"variationValues": {
						"body": "white"
					}
				}
			],
			"chair_leg": [
				{
					"id": "CL010",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white_oak"
					}
				},
				{
					"id": "CL010",
					"variationValues": {
						"body": "white_oak"
					}
				}
			]
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/products.json
// module id = 170
// module chunks = 5